
import Dashbord from '../components/Admin/Dashbord';
//import Dashbord from '../components/Admin/Old_Dashbord';
import Events from '../components/Admin/Events/AllEvents';
import AllUsers from '../components/Admin/Users/AllUsers';
import AllRoles from '../components/Admin/Role/AllRoles';
import AddUser from '../components/Admin/Users/AddUser';
import AddRole from '../components/Admin/Role/AddRole';
import EidtUser from '../components/Admin/Users/EidtUser';
import Permissions from '../components/Admin/permissions/Permissions';

// Abstract Routes
import AbstractDashbord from '../components/Admin/Abstract/AbstractDashbord';
import AddCategory from '../components/Admin/Abstract/Category/AddCategory';
import AllCategory from '../components/Admin/Abstract/Category/AllCategory';
//abstract Submisssion
import AddSubmissionType from '../components/Admin/Abstract/SubmissionType/AddSubmissionType';
import IndexSubmissionType from '../components/Admin/Abstract/SubmissionType/IndexSubmissionType';
//Article
import ApproveArticle from '../components/Admin/Abstract/Article/ApproveArticle';
import AddApproveArticle from '../components/Admin/Abstract/Article/AddApproveArticle';
import EditApproveArticle from '../components/Admin/Abstract/Article/EditApproveArticle';
import PendingList from '../components/Admin/Abstract/Article/PendingList';
import AddPendingList from '../components/Admin/Abstract/Article/AddPendingList';
import RejectList from '../components/Admin/Abstract/Article/RejectList';
import AddRejectList from '../components/Admin/Abstract/Article/AddRejectList';

//email template
import EmailEditor from '../components/Admin/Abstract/EmailTemplates/EmailEditor';
import AddEmailTempletes from '../components/Admin/Abstract/EmailTemplates/AddEmailTempletes';
import indexEmailTemplate from '../components/Admin/Abstract/EmailTemplates/indexEmailTemplate';
import AddEmailTemplateTitle from '../components/Admin/Abstract/EmailTemplates/AddEmailTemplateTitle';
//isssue
import IssuePendingArticle from '../components/Admin/Abstract/Article/IssuePendingArticle';
import AddIssuePending from '../components/Admin/Abstract/Article/AddIssuePending';
//Reviewer
import Reviewer from '../components/Admin/Abstract/Reviewer/Reviewer';
import ModeratorList from '../components/Admin/Abstract/Reviewer/ModeratorList';
import AddReviewer from '../components/Admin/Abstract/Reviewer/AddReviewer';
import EditReviewer from '../components/Admin/Abstract/Reviewer/EditReviewer';
import ReviewerReport from '../components/Admin/Abstract/Reviewer/ReviewerReport';
//Authors
import Author from '../components/Admin/Abstract/Author/Author';
//comments
import Comments from '../components/Admin/Abstract/Comments/Comments';
//Requirements
import Requirements from '../components/Admin/Abstract/Requirements/Requirements';
import AddRequirements from '../components/Admin/Abstract/Requirements/AddRequirements';
import EditRequirements from '../components/Admin/Abstract/Requirements/EditRequirements';
//Profile 
import Profile from '../components/Admin/Abstract/Profile/Profile';
import QustionsAnswer from '../components/Admin/AbstractScore/QustionsAnswer';
import AddQuestionScore from '../components/Admin/AbstractScore/AddQuestionScore';
import ViewQuestion from '../components/Admin/AbstractScore/ViewQuestion';
import EditQuestion from '../components/Admin/AbstractScore/EditQuestion';
import AllReview from '../components/Admin/AbstractScore/Score';
import Summary from '../components/Admin/AbstractScore/Summary';
import ShowSingleAbstractSummary from '../components/Admin/AbstractScore/ShowSingleAbstractSummary';
import UploadFinalPersentation from '../components/Admin/AbstractScore/UploadFinalPersentation';
//setting
import EmailSettings from '../components/Admin/settings/EmailSettings';
import CustomField from '../components/Admin/settings/CustomField';
import ListCustomFiels from '../components/Admin/settings/ListCustomFiels';
import InactiveListCustomFields from '../components/Admin/settings/InactiveListCustomFields';
import EditCustomField from '../components/Admin/settings/EditCustomField';
import GenralSetting from '../components/Admin/settings/GenralSetting';
import TestingEmail from '../components/Admin/settings/TestingEmail';
import Payment from '../components/Admin/settings/Payment';
import PayTabOne from '../components/Admin/settings/PayTabOne';
import PayTabTwo from '../components/Admin/settings/PayTabTwo';
import AbstractHomePAgeSettings from '../components/Admin/HomePages/AbstractHomePAgeSettings';
import IndexAbstractHomePageSettings from '../components/Admin/HomePages/IndexAbstractHomePageSettings';
import IndexOptionsAssgin from '../components/Admin/HomePages/IndexOptionsAssgin';
import AddOptionsAssgin from '../components/Admin/HomePages/AddOptionsAssgin';
// import Qrcode from '../components/Admin/Exhibition/QrCode/Qrcode';
//Notifiction
import Notifictions from '../components/Admin/Abstract/Notifiction/Notifictions';
//instructions
import Instruction from '../components/Admin/Abstract/Instructions/Instruction';
import AddInstruction from '../components/Admin/Abstract/Instructions/AddInstruction';
//eventIDaddFroAbstract
import AddEventID from '../components/Admin/Abstract/AddEventID';
import AuthorDashbords from '../components/Admin/Abstract/Author/AuthorDashbord';
//author edit
import EditArticle from '../components/Admin/Abstract/Author/EditArticle';
// Exhibition FrontEnd Routs 
import ExhibitionDashbord from '../components/Admin/Exhibition/ExhibitionDashbord';
import BoothCategory from '../components/Admin/Exhibition/Category/BoothCategory';
import AddBoothCategory from '../components/Admin/Exhibition/Category/AddBoothCategory';
import Booth from '../components/Admin/Exhibition/Booth/Booth';
import AddBooth from '../components/Admin/Exhibition/Booth/AddBooth';
import EditBooth from '../components/Admin/Exhibition/Booth/EditBooth';
import BookingBooth from '../components/Admin/Exhibition/Booking/BookingBooth';
import HoldBooth from '../components/Admin/Exhibition/Booking/HoldBooth';
import ReserveBooth from '../components/Admin/Exhibition/Booking/ReserveBooth';
import ExhibitorCategory from '../components/Admin/Exhibition/Exhibitor/ExhibitorCategory/ExhibitorCategory';
import EditExhibitorCategoy from '../components/Admin/Exhibition/Exhibitor/ExhibitorCategory/EditExhibitorCategoy';
import Exhibitor from '../components/Admin/Exhibition/Exhibitor/ExhibitorCategory/Exhibitor';
import AddNewExhibitor from '../components/Admin/Exhibition/Exhibitor/ExhibitorAdd/AddNewExhibitor';
import EditExhibitor from '../components/Admin/Exhibition/Exhibitor/ExhibitorAdd/EditExhibitor';
import AllExhibitor from '../components/Admin/Exhibition/Exhibitor/ExhibitorAdd/AllExhibitor';
import ExhibitorProfile from '../components/Admin/Exhibition/Exhibitor/ExhibitorAdd/ExhibitorProfile';
import GuestFromNatureOfBusiness from '../components/Admin/Exhibition/GuestFormFrontend/GuestFromNatureOfBusiness';
import GuestFromProductsAndServices from '../components/Admin/Exhibition/GuestFormFrontend/GuestFromProductsAndServices';
import IndexFromNature from '../components/Admin/Exhibition/GuestFormFrontend/IndexFromNature';
import IndexproductServices from '../components/Admin/Exhibition/GuestFormFrontend/IndexproductServices';
import EditProductServives from '../components/Admin/Exhibition/GuestFormFrontend/EditProductServives';
import EditNatureBusiness from '../components/Admin/Exhibition/GuestFormFrontend/EditNatureBusiness';
import ExhibitionBadge from '../components/Admin/Exhibition/ExhibitionBadge/ExhibitionBadge';
import EditBoothCategory from '../components/Admin/Exhibition/Category/EditBoothCategory';
import BadgeEditor from '../components/Admin/Exhibition/ExhibitionBadge/BadgeEditor';
import GusestVisiter from '../components/Admin/Exhibition/GuestVisit/GusestVisiter';
import IndexGuest from '../components/Admin/Exhibition/RegistratorGuest/IndexGuest';
import ScanByQrcode from '../components/Admin/Exhibition/RegistratorGuest/ScanByQrcode';
import EditGuest from '../components/Admin/Exhibition/RegistratorGuest/EditGuest';

//exhibition Email
import indexExhibitionEmailTemp from '../components/Admin/Exhibition/ExhibitionEmailTemp/indexExhibitionEmailTemp';
import AddExhibitionEmailTitle from '../components/Admin/Exhibition/ExhibitionEmailTemp/AddExhibitionEmailTitle';
import ExhibtionAddEmailTem from '../components/Admin/Exhibition/ExhibitionEmailTemp/ExhibtionAddEmailTem';
//WorkShops
import WorkShopDashbord from '../components/Admin/WorkShops/WorkShopDashbord';
import WorkshopCollections from '../components/Admin/WorkShops/WorkshopCollections';
import ManageWorkShopCategory from '../components/Admin/WorkShops/WorkShopCategory/ManageWorkShopCategory';
import AddWorkShopCategory from '../components/Admin/WorkShops/WorkShopCategory/AddWorkShopCategory';
import EditWorkShopCategory from '../components/Admin/WorkShops/WorkShopCategory/EditWorkShopCategory';

import ManageWorkShop from '../components/Admin/WorkShops/ManageWorkShop/ManageWorkShop';
import AddWorkShop from '../components/Admin/WorkShops/ManageWorkShop/AddWorkShop';
import EditworkShop from '../components/Admin/WorkShops/ManageWorkShop/EditworkShop';

import AddWorkShopUser from '../components/Admin/WorkShops/WorkShopUsers/AddWorkShopUser';
import ManageWorkShopUser from '../components/Admin/WorkShops/WorkShopUsers/ManageWorkShopUser';
import EditWorkShopUser from '../components/Admin/WorkShops/WorkShopUsers/EditWorkShopUser';
import AddWorkshopJoinAsCategory from '../components/Admin/WorkShops/WorkShopParticpant/WorkshopParticpantJoinAs/AddWorkshopJoinAsCategory';
import AddWorkShopParticpant from '../components/Admin/WorkShops/WorkShopParticpant/AddWorkShopParticpant';
import ManageWorkShopParticpant from '../components/Admin/WorkShops/WorkShopParticpant/ManageWorkShopParticpant';
import MangeWorkShopParticpantOrder from '../components/Admin/WorkShops/WorkShopParticpant/MangeWorkShopParticpantOrder';
import EditWorkShopParticpant from '../components/Admin/WorkShops/WorkShopParticpant/EditWorkShopParticpant';
import EditBasicInformationWorShopParticipant from '../components/Admin/WorkShops/WorkShopParticpant/EditBasicInformationWorShopParticipant';
import AddWorkShopCoupon from '../components/Admin/WorkShops/ManageCoupon/AddWorkShopCoupon';
import ManageWorkShopCoupon from '../components/Admin/WorkShops/ManageCoupon/ManageWorkShopCoupon';
import WorkshopReports from '../components/Admin/WorkShops/WorkshopReports/WorkshopReports';
import workshopReportMoreDeatils from '../components/Admin/WorkShops/WorkshopReports/workshopReportMoreDeatils';
import ShowSingleWorkShopCoupon from '../components/Admin/WorkShops/ManageCoupon/ShowSingleWorkShopCoupon';
//Workshop Emails Templates
import IndexWorkshopEmailTemp from '../components/Admin/WorkShops/WorkshopEmailTemp/IndexWorkshopEmailTemp';
import AddWorkshopEmailTitle from '../components/Admin/WorkShops/WorkshopEmailTemp/AddWorkshopEmailTitle';
import WorkshopAddEmailTemp from '../components/Admin/WorkShops/WorkshopEmailTemp/WorkshopAddEmailTemp';
//Conference
import ConferenceDashbord from '../components/Admin/Conference/ConferenceDashbord';
import ConferenceCollection from '../components/Admin/Conference/ConferenceCollection';
import ManageConferenceCategory from '../components/Admin/Conference/ConferenceCategory/ManageConferenceCategory';
import AddConferenceCategory from '../components/Admin/Conference/ConferenceCategory/AddConferenceCategory';
import EditConferenceCategory from '../components/Admin/Conference/ConferenceCategory/EditConferenceCategory';

import AddConferenceSession from '../components/Admin/Conference/ConferenceCategorySession/AddConferenceSession';
import ListConferenceSession from '../components/Admin/Conference/ConferenceCategorySession/ListConferenceSession';
import EditConferenceSession from '../components/Admin/Conference/ConferenceCategorySession/EditConferenceSession';
import ConferenceSessionsList from '../components/Admin/Conference/ConferenceSession/ConferenceSessionsList ';

import ConferenPJoinAs from '../components/Admin/Conference/ConferenceParticpant/ConferenceParticpantJoin/ConferenPJoinAs';
import AddConferenceParticipant from '../components/Admin/Conference/ConferenceParticpant/AddConferenceParticpant';

import AddConferenceSessionForm from '../components/Admin/Conference/ConferenceSession/AddConferenceSessionFrom';
import EditConferenceSessionForm from '../components/Admin/Conference/ConferenceSession/EditConferenceSessionFrom';

import ManageConference from '../components/Admin/Conference/ManageConference/ManageConference';
import EditConference from '../components/Admin/Conference/ManageConference/EditConference';
import AddConference from '../components/Admin/Conference/ManageConference/AddConference';
import ManageConferenceParticpant from '../components/Admin/Conference/ConferenceParticpant/ManageConferenceParticpant';
import ManageConferencePartitcpnatOrder from '../components/Admin/Conference/ConferenceParticpant/ManageConferencePartitcpnatOrder';
//---------------CONFERENCE EVENT CERTIFICATE ROUTE-----------------------------//
import ConferenceEventCertificate from '../components/Admin/Conference/ConferenceEventCertificate/ConferenceEventCertificate';
import ManageCoupon from '../components/Admin/Conference/ComferenceCoupon/ManageCoupon';
import AddConferenceCoupon from '../components/Admin/Conference/ComferenceCoupon/AddConferenceCoupon';
import ShowSingleConferenceCoupon from '../components/Admin/Conference/ComferenceCoupon/ShowSingleConferenceCoupon';
import ManageConferenceUser from '../components/Admin/Conference/ConferenceUser/ManageConferenceUser';
import EditBasicInfoConfParticipant from '../components/Admin/Conference/ConferenceParticpant/EditBasicInfoConfParticipant';
import EditConferenceParticpant from '../components/Admin/Conference/ConferenceParticpant/EditConferenceParticpant';
import ConferenceDailReport from '../components/Admin/Conference/ConferenceReports/ConferenceDailReport';
import RequriedForEvent from '../components/Admin/RequriedForEvent';
import ConferenceAddTermsAndConditions from '../components/Admin/Conference/ConferenceTermsAndConditions/ConferenceAddTermsAndConditions';

import EvaluationQuestionsAdmin from '../components/Admin/Conference/Evaluation/EvaluationQuestionsAdmin';
import ConferenceEvaluationList from '../components/Admin/Conference/Evaluation/ConferenceEvaltionList';
import ConferenceEvaluationChart from '../components/Admin/Conference/Evaluation/ConferenceEvalutionChart';

//conference speakers
import ConferenceSpeakerList from '../components/Admin/Conference/ConferenceParticpant/ConferenceSpeaker/ConferenceSpeakerList';

import ConferenceOrganizerUpload from '../components/Admin/Conference/ConferenceParticpant/ConferenceSpeaker/ConferenceOrganizerUpload';



//partitpant Login speaker dashboard
import ConferenceParticipantDashboard from '../Auth/Conference/ConferenceParticpantDashbord';
import ParticpantSingleEventDashbord from '../Auth/Conference/ParticpantSingleEventDashbord';
import ConferenceParticpantSpeakerDashbord from '../components/Speaker/ConferenceParticpantSpeakerDashbord';
import SpeakerUploadDocuments from '../components/Speaker/SpeakerUploadDoucments';
import ConferenceSpeakerEditForm from '../components/Speaker/ConferenceSpeakerEditFrom';
import ConferenceOrgSpeakerFiles from '../components/Speaker/ConferenceOrgSpeakerFiles';
//conference Emails
import IndexConferenceEmailTemp from '../components/Admin/Conference/ConferenceEmailTemp/IndexConferenceEmailTemp';
import AddConferenceEmailTitle from '../components/Admin/Conference/ConferenceEmailTemp/AddConferenceEmailTitle';
import AddConferenceEmailTemp from '../components/Admin/Conference/ConferenceEmailTemp/AddConferenceEmailTemp';
import ConferenceBadge from '../components/Admin/Conference/ConferenceBadge/ConferenceBadge';
import ConferenceCurrencyEnableDisable from '../components/Admin/Conference/ConferenceCurrency/ConferenceCurrencyEnableDisabale';
//Affiliation 
import AffiliationDashbord from '../components/Admin/Conference/ConferenceAffiliation/AffiliationDashbord';
import AffiliationCparticipantReport from '../components/Admin/Conference/ConferenceAffiliation/AffiliationCparticipantReport';
import AffiliationCpAttendanceReport from '../components/Admin/Conference/ConferenceAffiliation/AffiliationCpAttendanceReport';
import AffiliationCparticipnatBadge from '../components/Admin/Conference/ConferenceAffiliation/AffiliationCparticipnatBadge';


//import whatsAppMessenger from '../components/WhatsAppMessenger';
import WhatsAppMessenger from '../components/WhatsAppMessenger';
import WhatsAppCustomMessage from '../components/Admin/Conference/WhatsAppMessage/WhtasAppCustomMessage';

//import ConferenceEvaluationChart from '../components/Admin/Conference/Evaluation/ConferenceEvalutionChart';
//import EvaluationQuestionsAdmin from '../components/Admin/Conference/Evaluation/EvaluationQuestionsAdmin';
const Routes = [
    { path: '/admin', exact: true, name: 'Admin' },
    { path: '/admin/dashbord/:id', name: 'Dashbord', component: Dashbord },
    {/*Event Routes*/ },
    { path: '/admin/events', exact: true, name: 'Event', component: Events },
    // {path:'/admin/add-event',exact:true,name:'Event',component:AddEVent},
    // {/*user Routes*/},
    { path: '/admin/user', exact: true, name: 'User', component: AllUsers },
    { path: '/admin/adduser', exact: true, name: 'User', component: AddUser },
    { path: '/admin/edituser/:id', exact: true, name: 'User', component: EidtUser },
    // {path:'/admin/showuser/:id',exact:true, name:'User', component:ShowUser},

    //  Abstract Section Routes
    { path: '/admin/abstract/dashbord', exact: true, name: 'Abstract', component: AbstractDashbord },
    { path: '/admin/abstract/add-category', exact: true, name: 'Abstract', component: AddCategory },
    { path: '/admin/abstract/all-category', exact: true, name: 'Abstract', component: AllCategory },
    //abstract SubmissionType
    { path: '/admin/abstract/add-submission', exact: true, name: 'abstract', component: AddSubmissionType },
    { path: '/admin/abstract/submission', exact: true, name: 'abstract', component: IndexSubmissionType },

    //Article Section Routes
    { path: '/admin/abstract/approve-article', exact: true, name: 'Abstract', component: ApproveArticle },
    { path: '/admin/abstract/add-approve-article', exact: true, name: 'Abstract', component: AddApproveArticle },
    { path: '/admin/abstract/edit-approve-article/:id', exact: true, name: 'Abstract', component: EditApproveArticle },

    { path: '/admin/abstract/pending-article', exact: true, name: 'Abstract', component: PendingList },
    { path: '/admin/abstract/add-pending-article', exact: true, name: 'Abstract', component: AddPendingList },

    { path: '/admin/abstract/reject-article', exact: true, name: 'Abstract', component: RejectList },
    { path: '/admin/abstract/add-reject-article', exact: true, name: 'Abstract', component: AddRejectList },

    //email temaple

    { path: '/admin/abstract/email-template/:id', exact: true, name: 'EmailEditor', component: EmailEditor },
    { path: '/admin/abstract/add-template', exact: true, name: 'AddEmailTempletes', component: AddEmailTempletes },
    { path: '/admin/abstract/index-template', exact: true, name: 'indexEmailTemplate', component: indexEmailTemplate },
    { path: '/admin/abstract/title-template', exact: true, name: 'AddEmailTemplateTitle', component: AddEmailTemplateTitle },


    //issue

    { path: '/admin/abstract/issue-pending-article', exact: true, name: 'Issue', component: IssuePendingArticle },
    { path: '/admin/abstract/add-issue-pending-article/:id', exact: true, name: 'Issue', component: AddIssuePending },

    //Comments
    { path: '/admin/comments/comments', exact: true, name: 'Comments', component: Comments },
    //Requirements
    { path: '/admin/requirements/requirements', exact: true, name: 'Requirements', component: Requirements },
    { path: '/admin/requirements/add-requirements', exact: true, name: 'Requirements', component: AddRequirements },
    { path: '/admin/requirements/eidt-requirements/:id', exact: true, name: 'Requirements', component: EditRequirements },
    //Reviewer
    { path: '/admin/reviewer/reviewer-list', exact: true, name: 'Reviewer', component: Reviewer },
    { path: '/admin/moderator/moderator-list', exact: true, name: 'ModeratorList', component: ModeratorList },

    { path: '/admin/reviewer/add-reviewer', exact: true, name: 'Reviewer', component: AddReviewer },
    { path: '/admin/reviewer/edit-reviewer/:id', exact: true, name: 'Reviewer', component: EditReviewer },
    { path: '/admin/reviewer/report/:id', exact: true, name: 'Reviewer', component: ReviewerReport },

    { path: '/admin/author/author-list', exact: true, name: 'Author', component: Author },

    //Profile setting
    { path: '/admin/profile/profile', exact: true, name: 'Profile', component: Profile },
    { path: '/admin/questions/answers', exact: true, name: 'QuestionAnswer', component: QustionsAnswer },
    { path: '/admin/email/setting', exact: true, name: 'EmailSettings', component: EmailSettings },
    { path: '/admin/general/setting', exact: true, name: 'GenralSetting', component: GenralSetting },
    { path: '/admin/from/custom-field', exact: true, name: 'CustomField', component: CustomField },
    { path: '/admin/from/custom-list', exact: true, name: 'ListCustomFiels', component: ListCustomFiels },
    { path: '/admin/test/email', exact: true, name: 'TestingEmail', component: TestingEmail },
    { path: '/admin/payment/setting', exact: true, name: 'Payment', component: Payment },
    { path: '/admin/payment/paytab', exact: true, name: 'PayTabOne', component: PayTabOne },
    { path: '/admin/payment/paytab-two', exact: true, name: 'PayTabTwo', component: PayTabTwo },
    { path: '/admin/abstract/home-page', exact: true, name: 'AbstractHomePAgeSettings', component: AbstractHomePAgeSettings },
    { path: '/admin/abstract/index-home-page', exact: true, name: 'IndexAbstractHomePageSettings', component: IndexAbstractHomePageSettings },
    { path: '/admin/options/index-assign', exact: true, name: 'IndexOptionsAssgin', component: IndexOptionsAssgin },
    { path: '/admin/options/assign', exact: true, name: 'AddOptionsAssgin', component: AddOptionsAssgin },


    { path: '/admin/from/inactive-custom-list', exact: true, name: 'InactiveListCustomFields', component: InactiveListCustomFields },
    { path: '/admin/from/edit/custom-list/:id', exact: true, name: 'EditCustomField', component: EditCustomField },


    // {path:'/admin/exhibition/qrcode',exact:true,name:'Qrcode',component:Qrcode},

    //inside in penddinglist
    { path: '/admin/abstract/add-score/:id', exact: true, name: 'QuestionScore', component: AddQuestionScore },
    { path: '/admin/abstract/view-score/:id', exact: true, name: 'ViewScore', component: ViewQuestion },
    { path: '/admin/abstract/edit-question/:id', exact: true, name: 'EditScore', component: EditQuestion },
    { path: '/admin/abstract/all-review/:id', exact: true, name: 'AllReview', component: AllReview },
    { path: '/admin/abstract/summary/:id', exact: true, name: 'Summary', component: Summary },
    { path: '/admin/abstract/singleabstract/:id', exact: true, name: 'ShowSingleAbstractSummary', component: ShowSingleAbstractSummary },
    { path: '/admin/final/presentation/:id', exact: true, name: 'UploadFinalPersentation', component: UploadFinalPersentation },
    //notifiction 
    { path: '/admin/notifictions/notifictions', exact: true, name: 'Notifictions', component: Notifictions },
    //instructions
    { path: '/admin/instruction/instruction', exact: true, name: 'Instruction', component: Instruction },
    { path: '/admin/addinstruction/addinstruction', exact: true, name: 'Instruction', component: AddInstruction },
    //AddEventID
    { path: '/admin/addeventid', exact: true, name: 'EventID', component: AddEventID },
    //authorDashbord
    { path: '/admin/author/dashbord', exact: true, name: 'AuthorDashord', component: AuthorDashbords },
    { path: '/admin/author/abstract/edit-approve-article/:id', exact: true, name: 'EditArticle', component: EditArticle },

    // Exhibition  Routs

    { path: '/admin/exhibition/dashbord', exact: true, name: 'ExhibitionDashbord', component: ExhibitionDashbord },
    { path: '/admin/exhibition/boothcategory', exact: true, name: 'BoothCategory', component: BoothCategory },
    { path: '/admin/exhibition/addboothcategory', exact: true, name: 'AddBoothCategory', component: AddBoothCategory },
    { path: '/admin/exhibition/exhibitorcategory-edit/:id', exact: true, name: 'EditBoothCategory', component: EditBoothCategory },

    { path: '/admin/exhibition/booth', exact: true, name: 'Booth', component: Booth },
    { path: '/admin/exhibition/booking', exact: true, name: 'BookingBooth', component: BookingBooth },
    { path: '/admin/exhibition/reserve', exact: true, name: 'ReserveBooth', component: ReserveBooth },
    { path: '/admin/exhibition/hold', exact: true, name: 'HoldBooth', component: HoldBooth },

    { path: '/admin/exhibition/addbooth', exact: true, name: 'AddBooth', component: AddBooth },
    { path: '/admin/exhibition/edit-booth/:id', exact: true, name: 'EditBooth', component: EditBooth },

    { path: '/admin/exhibition/exhibitorcategory', exact: true, name: 'ExhibitorCategory', component: ExhibitorCategory },
    { path: '/admin/exhibition/exhibitorcate-edit/:id', exact: true, name: 'EditExhibitorCategoy', component: EditExhibitorCategoy },

    { path: '/admin/exhibition/exhibitor', exact: true, name: 'Exhibitor', component: Exhibitor },
    { path: '/admin/exhibition/addexhibitor', exact: true, name: 'AddNewExhibitor', component: AddNewExhibitor },
    { path: '/admin/exhibition/edit-exhibitor/:id', exact: true, name: 'EditExhibitor', component: EditExhibitor },

    { path: '/admin/exhibition/allexhibitor', exact: true, name: 'AllExhibitor', component: AllExhibitor },
    { path: '/admin/exhibition/exhibitor-profile', exact: true, name: 'ExhibitorProfile', component: ExhibitorProfile },
    { path: '/admin/exhibition/index-nature', exact: true, name: 'IndexFromNature', component: IndexFromNature },
    { path: '/admin/exhibition/natureofbusiness', exact: true, name: 'GuestFromNatureOfBusiness', component: GuestFromNatureOfBusiness },
    { path: '/admin/exhibition/productsandservices', exact: true, name: 'GuestFromProductsAndServices', component: GuestFromProductsAndServices },
    { path: '/admin/exhibition/index-services', exact: true, name: 'IndexproductServices', component: IndexproductServices },
    { path: '/admin/exhibition/product-services-edit/:id', exact: true, name: 'EditProductServives', component: EditProductServives },
    { path: '/admin/exhibition/nature-business-edit/:id', exact: true, name: 'EditNatureBusiness', component: EditNatureBusiness },
    { path: '/admin/exhibition/badge', exact: true, name: 'ExhibitionBadge', component: ExhibitionBadge },
    { path: '/admin/exhibition/visitor', exact: true, name: 'GusestVisiter', component: GusestVisiter },
    { path: '/admin/exhibition/guest', exact: true, name: 'IndexGuest', component: IndexGuest },
    { path: '/admin/exhibition/edit-guest/:id', exact: true, name: 'EditGuest', component: EditGuest },
    { path: '/admin/exhibitor/scan', exact: true, name: 'ScanByQrcode', component: ScanByQrcode },

    //exhibition email
    { path: '/admin/exhibition/index-email', exact: true, name: 'indexExhibitionEmailTemp', component: indexExhibitionEmailTemp },
    { path: '/admin/exhibition/add-title', exact: true, name: 'AddExhibitionEmailTitle', component: AddExhibitionEmailTitle },
    { path: '/admin/exhibition/add-template', exact: true, name: 'ExhibtionAddEmailTem', component: ExhibtionAddEmailTem },
    ///admin/exhibition/add-template 

    //WorkShops

    { path: '/admin/workshop/dashbord', exact: true, name: 'WorkShopDashbord', component: WorkShopDashbord },
    { path: '/admin/workshop/collections', exact: true, name: 'WorkShopDashbord', component: WorkshopCollections },
    { path: '/admin/workshop/category', exact: true, name: 'ManageWorkShopCategory', component: ManageWorkShopCategory },
    { path: '/admin/workshop/edit-category/:id', exact: true, name: 'EditWorkShopCategory', component: EditWorkShopCategory },


    { path: '/admin/workshop/add-category', exact: true, name: 'AddWorkShopCategory', component: AddWorkShopCategory },
    { path: '/admin/workshop/manage', exact: true, name: 'ManageWorkShop', component: ManageWorkShop },
    { path: '/admin/workshop/add', exact: true, name: 'AddWorkShop', component: AddWorkShop },
    { path: '/admin/workshop/edit/:id', exact: true, name: 'EditworkShop', component: EditworkShop },


    { path: '/admin/workshop/user', exact: true, name: 'AddWorkShopUser', component: AddWorkShopUser },
    { path: '/admin/workshop/manage-user', exact: true, name: 'ManageWorkShopUser', component: ManageWorkShopUser },

    { path: '/admin/workshop/user-edit/:id', exact: true, name: 'EditWorkShopUser', component: EditWorkShopUser },


    { path: '/admin/particpant/join-as', exact: true, name: 'AddWorkshopJoinAsCategory', component: AddWorkshopJoinAsCategory },
    { path: '/admin/workshop/particpant', exact: true, name: 'AddWorkShopParticpant', component: AddWorkShopParticpant },
    { path: '/admin/workshop/manage-particpant', exact: true, name: 'ManageWorkShopParticpant', component: ManageWorkShopParticpant },
    { path: '/admin/workshop/manage-particpant-order', exact: true, name: 'MangeWorkShopParticpantOrder', component: MangeWorkShopParticpantOrder },
    { path: '/admin/workshop/eidt-particpant/:id', exact: true, name: 'EditWorkShopParticpant', component: EditWorkShopParticpant },
    { path: '/admin/workshop/basic-particpant/:id', exact: true, name: 'EditBasicInformationWorShopParticipant', component: EditBasicInformationWorShopParticipant },


    { path: '/admin/workshop/add-coupon', exact: true, name: 'AddWorkShopCoupon', component: AddWorkShopCoupon },
    { path: '/admin/workshop/manage-coupon', exact: true, name: 'ManageWorkShopCoupon', component: ManageWorkShopCoupon },
    { path: '/admin/workshop/show-coupon/:id', exact: true, name: 'ShowSingleWorkShopCoupon', component: ShowSingleWorkShopCoupon },
    { path: '/admin/workshop/reports', exact: true, name: 'WorkshopReports', component: WorkshopReports },
    { path: '/admin/workshop/more-details/:id', exact: true, name: 'workshopReportMoreDeatils', component: workshopReportMoreDeatils },
    //workshop email templates
    { path: '/admin/workshop/index-email', exact: true, name: 'IndexWorkshopEmailTemp', component: IndexWorkshopEmailTemp },
    { path: '/admin/workshop/add-title', exact: true, name: 'AddWorkshopEmailTitle', component: AddWorkshopEmailTitle },
    { path: '/admin/workshop/add-template', exact: true, name: 'WorkshopAddEmailTemp', component: WorkshopAddEmailTemp },

    // {/*Role Routes*/},
    { path: '/admin/role', exact: true, name: 'Role', component: AllRoles },
    { path: '/admin/create-role', exact: true, name: 'AddRole', component: AddRole },

    // {/*Permissions Routes*/},
    { path: '/admin/role/permissions/:id', exact: true, name: 'Permissions', component: Permissions },

    //Conference Routes Start
    { path: '/admin/conference/dashbord', exact: true, name: 'ConferenceDashbord', component: ConferenceDashbord },
    { path: '/admin/conference/collection', exact: true, name: 'ConferenceCollection', component: ConferenceCollection },

    { path: '/admin/conference/category', exact: true, name: 'ManageConferenceCategory', component: ManageConferenceCategory },
    { path: '/admin/conference/add-category', exact: true, name: 'AddConferenceCategory', component: AddConferenceCategory },
    { path: '/admin/conference/edit-category/:id', exact: true, name: 'EditConferenceCategory', component: EditConferenceCategory },
    { path: '/admin/conference/add-session', exact: true, name: 'AddConferenceSession', component: AddConferenceSession },
    { path: '/admin/conference/list-session', exact: true, name: 'ListConferenceSession', component: ListConferenceSession },
    { path: '/admin/conference/edit-session/:id', exact: true, name: 'EditConferenceSession', component: EditConferenceSession }, //

    { path: '/admin/conference/join-as', exact: true, name: 'ConferenPJoinAs', component: ConferenPJoinAs },
    { path: '/admin/conference/add-particpant', exact: true, name: 'AddConferenceParticipant', component: AddConferenceParticipant },

    { path: '/admin/conference/add-session-form', exact: true, name: 'AddConferenceSessionForm', component: AddConferenceSessionForm },
    { path: '/admin/conference/sessions-list', exact: true, name: 'ConferenceSessionsList', component: ConferenceSessionsList },
    { path: '/admin/conference/edit-session-form/:id', exact: true, name: 'EditConferenceSessionForm', component: EditConferenceSessionForm },

    { path: '/admin/conference/manage', exact: true, name: 'ManageConference', component: ManageConference },
    { path: '/admin/conference/add', exact: true, name: 'AddConference', component: AddConference },
    { path: '/admin/conference/edit/:id', exact: true, name: 'EditConference', component: EditConference },

    { path: '/admin/conference/manage-particpant', exact: true, name: 'ManageConferenceParticpant', component: ManageConferenceParticpant },
    { path: '/admin/conference/manage-particpant-order', exact: true, name: 'ManageConferencePartitcpnatOrder', component: ManageConferencePartitcpnatOrder },
    //------------CONFERENCE EVENT CERTIFICATE ROUTE-----------------------------//
    { path: '/admin/conference/conference-event-certificate', exact: true, name: 'ConferenceEventCertificate', component: ConferenceEventCertificate },


    { path: '/admin/conference/manage-coupon', exact: true, name: 'ManageCoupon', component: ManageCoupon },
    { path: '/admin/conference/add-coupon', exact: true, name: 'AddConferenceCoupon', component: AddConferenceCoupon },
    { path: '/admin/conference/show-coupon/:id', exact: true, name: 'ShowSingleConferenceCoupon', component: ShowSingleConferenceCoupon },

    { path: '/admin/conference/manage-user', exact: true, name: 'ManageConferenceUser', component: ManageConferenceUser },
    { path: '/admin/conference/basic-particpant/:id', exact: true, name: 'EditBasicInfoConfParticipant', component: EditBasicInfoConfParticipant },
    { path: '/admin/conference/eidt-particpant/:id', exact: true, name: 'EditConferenceParticpant', component: EditConferenceParticpant },
    { path: '/admin/conference/reports', exact: true, name: 'ConferenceDailReport', component: ConferenceDailReport },
    { path: '/admin/conference/requried-for-event', exact: true, name: 'RequriedForEvent', component: RequriedForEvent },

    { path: '/admin/conference/index-email', exact: true, name: 'IndexConferenceEmailTemp', component: IndexConferenceEmailTemp },
    { path: '/admin/conference/add-title', exact: true, name: 'AddConferenceEmailTitle', component: AddConferenceEmailTitle },
    { path: '/admin/conference/add-template', exact: true, name: 'AddConferenceEmailTemp', component: AddConferenceEmailTemp },
    { path: '/admin/conference/badge', exact: true, name: 'ConferenceBadge', component: ConferenceBadge },
    { path: '/admin/conference/currency', exact: true, name: 'ConferenceCurrencyEnableDisable', component: ConferenceCurrencyEnableDisable },
    { path: '/admin/conference/terms-and-conditions', exact: true, name: 'ConferenceAddTermsAndConditions', component: ConferenceAddTermsAndConditions },
    { path: '/admin/conference/evaluation-questions-admin', exact: true, name: "EvaluationQuestionsAdmin", component: EvaluationQuestionsAdmin },
    { path: '/admin/conference/evaluation-list', exact: true, name: "ConferenceEvaluationList", component: ConferenceEvaluationList },
    { path: '/admin/conference/chart-report', exact: true, name: "ConferenceEvaluationChart", component: ConferenceEvaluationChart },

    //Conference Participant Dashboard speaker dashboard
    { path: '/admin/conference/participant-dashboard', exact: true, name: "ConferenceParticipantDashboard", component: ConferenceParticipantDashboard },
    { path: '/admin/conference/single-event-dashbord/:id', exact: true, name: "ParticpantSingleEventDashbord", component: ParticpantSingleEventDashbord },
    { path: '/admin/conference/speaker-dashbord/:id', exact: true, name: "ConferenceParticpantSpeakerDashbord", component: ConferenceParticpantSpeakerDashbord },
    { path: '/admin/conference/speaker-upload-documents', exact: true, name: "SpeakerUploadDocuments", component: SpeakerUploadDocuments },
    { path: '/admin/conference/speaker-edit/:id', exact: true, name: "ConferenceSpeakerEditForm", component: ConferenceSpeakerEditForm },

     {path: '/admin/conference/upload-org-file', exact:true , name:"ConferenceOrgSpeakerFiles" ,component:ConferenceOrgSpeakerFiles},


    //Conference Speakers}
    { path: '/admin/conference/manage-speaker', exact: true, name: "ConferenceSpeakerList", component: ConferenceSpeakerList },
    { path: '/admin/conference/upload-speaker-file', exact: true, name: "ConferenceOrganizerUpload", component: ConferenceOrganizerUpload },

    //whatsApp Messenger
    {path:'/admin/whatsapp-messenger',exact:true,name:'WhatsAppMessenger',component:WhatsAppMessenger},
   {path:'/admin/conference/whatsapp-custom-message',exact:true,name:'WhatsAppCustomMessage',component:WhatsAppCustomMessage},
    //affiliation
    { path: '/admin/affiliation/dashbord', exact: true, name: 'AffiliationDashbord', component: AffiliationDashbord },
    { path: '/admin/affiliation/participant-report', exact: true, name: 'AffiliationCparticipantReport', component: AffiliationCparticipantReport },
    { path: '/admin/affiliation/attendance-report', exact: true, name: 'AffiliationCpAttendanceReport', component: AffiliationCpAttendanceReport },
    { path: '/admin/affiliation/badge', exact: true, name: 'AffiliationCparticipnatBadge', component: AffiliationCparticipnatBadge },
];



export default Routes;

